import { BatteryDetailsType } from '@ukpostbox/client-data';
import { FormProvider, useForm } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useState } from 'react';
import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';
import { RenderBatchSectionType } from '../../Types/ForwardingBatchTypes';
import { AccountNamesCombobox } from '../Controls/AccountNamesCombobox';
import { BatchBatteryDeclarationComplete } from './BatchBatteryDeclarationComplete';
import { LithiumBatteryWithEquipment } from './LithiumBatteryWithEquipment';
import { LithiumBatteryInEquipment } from './LithiumBatteryInEquipment';
import { MetalBatteryWithEquipment } from './MetalBatteryWithEquipment';

function BatchBatteryDeclaration(props: RenderBatchSectionType) {
	const { currentBatchData, UpdateBatteryDeclaration } = useForwardingBatchProvider();

	const formMethods = useForm({
		defaultValues: {
			batteryDeclaration: currentBatchData?.batteryDetails,
		},
		mode: 'onChange',
	});

	const [batteryDeclaration, setBatteryDeclaration] = useState<BatteryDetailsType>({
		lithiumBatteriesInEquipment: currentBatchData?.batteryDetails?.lithiumBatteriesInEquipment || false,
		lithiumBatteriesWithEquipment: currentBatchData?.batteryDetails?.lithiumBatteriesWithEquipment || false,
		metalBatteriesWithEquipment: currentBatchData?.batteryDetails?.metalBatteriesWithEquipment || false,
		shippersName: currentBatchData?.batteryDetails?.shippersName || '',
	});

	const UpdateSelectedBatteries = (name: string, value: any) => {
		const newData = {
			...batteryDeclaration,
			[name]: value,
		};

		setBatteryDeclaration(newData);
		UpdateBatteryDeclaration(newData);
	};

	if (props.complete) return <BatchBatteryDeclarationComplete {...props} />;

	return (
		<FormProvider {...formMethods}>
			<div>
				<h5 className='mb-xs'>{`Step ${props.sectionIndex}: ${props.section.name}`}</h5>

				<div className='row mb-md'>
					<div className='col-md-4'>
						<div className='input-group'>
							<label>Shipper's Name ( {batteryDeclaration.shippersName} )</label>
							<AccountNamesCombobox
								name='shippersName'
								defaultValue={currentBatchData?.batteryDetails?.shippersName}
								callback={(item) => UpdateSelectedBatteries('shippersName', item.label)}
								disabled={props.readOnly || props.complete}
							/>
						</div>
					</div>
				</div>

				<div className='row'>
					<div className='col-md-8'>
						<div className='secondary p-sm round mb-xs'>Lithium</div>
						<div className='row'>
							<div className='col-md-6 align-'>
								<LithiumBatteryWithEquipment
									onChangeCallback={(state) =>
										UpdateSelectedBatteries('lithiumBatteriesWithEquipment', state)
									}
									complete={props.complete}
									readOnly={props.readOnly}
									defaultSelected={batteryDeclaration.lithiumBatteriesWithEquipment}
								/>
							</div>
							<div className='col-md-6'>
								<LithiumBatteryInEquipment
									onChangeCallback={(state) =>
										UpdateSelectedBatteries('lithiumBatteriesInEquipment', state)
									}
									complete={props.complete}
									readOnly={props.readOnly}
									defaultSelected={batteryDeclaration.lithiumBatteriesInEquipment}
								/>
							</div>
						</div>
					</div>
					<div className='col-md-4'>
						<div className='secondary p-sm round mb-xs'>Metal</div>
						<div className='row'>
							<div className='col-md-12'>
								<MetalBatteryWithEquipment
									onChangeCallback={(state) =>
										UpdateSelectedBatteries('metalBatteriesWithEquipment', state)
									}
									complete={props.complete}
									readOnly={props.readOnly}
									defaultSelected={batteryDeclaration.metalBatteriesWithEquipment}
								/>
							</div>
						</div>
					</div>
				</div>

				{!props.complete && (
					<div className='row'>
						<div className='col-md-4'>
							<p>Maximum of 20 watt hours per cell, or 100 watt hours per battery</p>
							<p>
								Typically used to power portable, and larger, electronic devices (Laptops, Cordless
								Power Tools, etc).
							</p>
						</div>
						<div className='col-md-4' />
						<div className='col-md-4'>
							<p>Maximum of 20 watt hours per cell, or 100 watt hours per battery</p>
							<p>
								Commonly single use, and easily interchangeable, used in household items like remote
								controls and chldrens toys (AA, AAA, D, etc).
							</p>
						</div>
					</div>
				)}
			</div>
		</FormProvider>
	);
}

export { BatchBatteryDeclaration };
